import React from 'react';

import LoadingButton from '../common/LoadingButton';

type LabelRequired = { label: string; children?: React.ReactNode };
type ChildrenRequired = { label?: string; children: React.ReactNode };

export type SubmitButtonProps = (LabelRequired | ChildrenRequired) & {
    isLoading?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

function SubmitButton({ label, isLoading, onClick, children }: SubmitButtonProps) {
    return (
        <LoadingButton
            type="submit"
            className={`btn btn-primary ${isLoading ? 'disabled' : ''}`}
            isLoading={isLoading}
            onClick={onClick}
        >
            {children ?? label}
        </LoadingButton>
    );
}

export default SubmitButton;
